export default __webpack_public_path__ + "static/media/12-glavk-logo.20614fb5.png";